import qs from 'qs'
import config from "@/config/index"

exports.install = function (Vue, opentions) {
  //跳转页面
  Vue.prototype.intent = function (paths, obj) {
    this.$router.push({path: paths, query: obj})
  };

  //日志
  Vue.prototype.log = function (msg) {
    if (config.plugin.logs) {
      console.log(msg)
    }
  }

  //请求 请求地址 obj 请求内容 that上下文对象 code 识别码区分回调 types 不传默认get请求
  Vue.prototype.myrequest = function (obj) {
    // console.log(obj,928287239)
    if (obj.data == null) {
      obj.data = {
        token: "",
      }
    }
    obj.data.token = this.$store.state.token
    this.$createTos({
      $props: {
        title: obj.msg ? obj.msg : '加载中...'
      },
    }).showtos();
    var myobj = {
      url: config.baseUrl.pro + obj.url, //判断是否线上线下
      method: "",
    }
    if (typeof (obj.types) == undefined || obj.types == "" || obj.types == null || obj.types == "get") {
      myobj.method = "get"
      myobj.params = obj.data
    } else {
      myobj.method = obj.types
      let formdata = qs.stringify(obj.data)
      myobj.data = formdata
    }
    this.$axios(myobj).then(res => {
      this.$createTos().closetos()
      if (res.data.status == 1) {

        obj.succ(res.data);
      } else if (res.data.status == 0) {
        obj.errs(res.data.msg);
      }else if(res.data.status==10001){
        this.$router.push({path:'/login'})
      }
    }).catch(error => {
      this.$createTos().closetos()
      obj.errs("抱歉！服务器开了个小差");
    })
  };



}



// WEBPACK FOOTER //
// ./src/common/js/uilts.js